import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { OwnerComponent } from './owner/owner.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { MaterialModule } from 'src/app/material.module';
import { MatIcon } from '@angular/material/icon';
import { DialogComponent } from '../dialog/confirm.dialog';
import { firstValueFrom } from 'rxjs';
import { leadServices } from 'src/app/services/leads.service';

@Component({
  selector: 'app-action-page',
  standalone: true,
  imports: [MatMenuModule,MatButtonModule,MatIcon],
  templateUrl: './action-page.component.html',
  styleUrl: './action-page.component.scss'
})
export class ActionPageComponent {
  constructor(private dialog:MatDialog,private leadService:leadServices){}

  isDropdownOpen = false;
  isStopMessage:boolean=false
  @Input() lead:any;
  @Output() updateOwner = new EventEmitter<any>();
  @Output() updateStopMessage = new EventEmitter<any>();
  
  currentLead:any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['lead']) {
      this.currentLead=changes['lead'].currentValue
      this.isStopMessage = this.currentLead.stop_messages
    }
  }
  
  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }
 
  async stopMessages(){
    const textDirection = this.isStopMessage? 'Allow' : 'Stop'
    const responseConfirm = await this.callDialog(
      `This will ${textDirection} Messaging This Lead!`,`Are you sure you want to proceed?`,false,'500px'
    );

    if(responseConfirm){
       const response = await firstValueFrom(this.leadService.patchGeneral({stop_messages:!this.isStopMessage},this.currentLead.id))
       if(response){
        this.isStopMessage = !this.isStopMessage
        this.updateStopMessage.emit(this.isStopMessage)
       }
    }
    
  }

  openOwnerModal(type:string): void {
    const width = type =='user'? '400px':'500px'
    const dialogRef = this.dialog.open(OwnerComponent, {
      width,
      data: {lead:this.currentLead,type},
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.success) {
         this.updateOwner.emit(result)
      }
      this.isDropdownOpen=false
    });
  }
  
    callDialog(header: string, content: string,isInfo:boolean,width:string,contentList?) {
      const dialogRef = this.dialog.open(DialogComponent, {
        data: {
          header,
          content,
          isInfo,
          contentList
        },
        width,
      });
  
      return dialogRef.afterClosed().toPromise();
    }
}
